import { Body, H1 } from "@casavo/habitat"
import useTranslation from "next-translate/useTranslation"
import { FC } from "react"

import { Compliance } from "@app/shared/types/website-pages"

import { documents, documentsItem, documentsItemMobile, documentsItemIframe, titleCenter } from "./styles.css"

export const ComplianceContent: FC = () => {
  const { t } = useTranslation("compliance")
  const { antiCorruption, ethics } = t<Compliance>("compliance", {}, { returnObjects: true })
  const ethicsFallback = "Group Code of Ethics and Conduct"
  const antiCorruptionFallback = "Global Anti-Corruption Compliance Policy"

  return (
    <main>
      <div className={titleCenter}>
        <H1>Compliance</H1>
      </div>
      <div className={documents}>
        <div className={documentsItem}>
          <a
            aria-label={ethics ? ethics : ethicsFallback}
            className={documentsItemMobile}
            href="/pdf/group-code-of-ethics-and-conduct.pdf"
          >
            <Body strong size="l">
              {ethics ? ethics : ethicsFallback}
            </Body>
          </a>

          <Body strong size="l">
            {ethics ? ethics : ethicsFallback}
          </Body>

          <iframe
            className={documentsItemIframe}
            src="/pdf/group-code-of-ethics-and-conduct.pdf"
            title={ethics ? ethics : ethicsFallback}
            width="100%"
          ></iframe>
        </div>

        <div className={documentsItem}>
          <a
            aria-label={antiCorruption ? antiCorruption : antiCorruptionFallback}
            className={documentsItemMobile}
            href="/pdf/global-anti-corruption-compliance-policy.pdf"
          >
            <Body strong size="l">
              {antiCorruption ? antiCorruption : antiCorruptionFallback}
            </Body>
          </a>

          <Body strong size="l">
            {antiCorruption ? antiCorruption : antiCorruptionFallback}
          </Body>

          <iframe
            className={documentsItemIframe}
            src="/pdf/global-anti-corruption-compliance-policy.pdf"
            title={antiCorruption ? antiCorruption : antiCorruptionFallback}
            width="100%"
          ></iframe>
        </div>
      </div>
    </main>
  )
}
